import { FC } from 'react';
import { Box } from '@mui/material';

export const NotFound: FC = () => {
  return <Box>Not Found page</Box>;
};
